module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-hover"
  }, [_c('img', {
    staticClass: "pic-def",
    attrs: {
      "src": _vm.src,
      "width": _vm.width
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hover-cont"
  }, [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f984a05e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/ImgHover.vue
// module id = 895
// module chunks = 0